import { Button, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import { BsCameraVideo } from "react-icons/bs";
import { IoCallOutline } from "react-icons/io5";

function CallButtons({ setShowCall }) {
  const btn1Color = useColorModeValue("#7CD892", "#2DA350");
  const btn2Color = useColorModeValue("#FF686B", "#FF4246");

  return (
    <Stack direction={"row"} alignItems="center" justifyContent={"center"} display={"none"}>
      <Button
        h="30px"
        fontSize={".9em"}
        size={"sm"}
        bg={btn1Color}
        color="#fff"
        borderRadius={"15px"}
      >
        <Stack
          direction="row"
          alignItems={"center"}
          cursor="pointer"
          onClick={() => setShowCall(true)}
        >
          <IoCallOutline />
          <Text fontSize={".8em"}>Voice chat</Text>
        </Stack>
      </Button>
      <Button
        h="30px"
        fontSize={".9em"}
        size={"sm"}
        bg={btn2Color}
        color="#fff"
        borderRadius={"15px"}
      >
        <Stack
          direction="row"
          alignItems={"center"}
          cursor="pointer"
          onClick={() => setShowCall(true)}
        >
          <BsCameraVideo />
          <Text fontSize={".8em"}>Video call</Text>
        </Stack>
      </Button>
    </Stack>
  );
}

export default CallButtons;
